import bgVideo from '../assets/bg_video.mp4';

function BackgroundVideo() {
    return (
        <video autoPlay loop muted style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
            <source src={bgVideo} type='video/mp4' />
        </video>
    );
}

export default BackgroundVideo;